// Copyright (C) 2021 Bystronic Laser AG

import { useRootStore } from '@/store';

export class SpinnerPluginService {
  showSpinner() {
    useRootStore().showSpinner();
  }

  removeSpinner() {
    useRootStore().removeSpinner();
  }
}
